import React from 'react'
import { Avatar, Box, Card, CardMedia, Grid, SvgIcon, Typography } from '@mui/material'
import { Divider } from '@mui/material';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';

import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import PlayCircleOutlineOutlinedIcon from '@mui/icons-material/PlayCircleOutlineOutlined';

const brands = ["Perfora", "Renee", "Sanfe"]

const style = (theme) => ({
    width: "50%",
    height: "fit-content",
    borderRadius: '20px',
    padding: '16px',
    backgroundColor: theme.palette.mode === 'dark' ? '#0A1929' : 'white',
    boxShadow: `0px 2px 24px ${theme.palette.mode === 'dark' ? '#000' : '#383838'}`,
});

function formatNumber(number) {
    if (number >= 1e6) {
        return (number / 1e6).toFixed(2) + "M";
    } else if (number >= 1e3) {
        return (number / 1e3).toFixed(2) + "K";
    } else {
        return number.toFixed(2);
    }
}


function VideoCard(props) {

    const videoData = props.videoData;

    const commentsIcon = (
        <SvgIcon style={{ width: "20px", height: "20px" }}>
            <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.60693 31.0434L4.71518 21.7187C3.23816 18.7655 2.86024 15.3831 3.64906 12.1767C4.43788 8.97036 6.34195 6.14934 9.02053 4.21849C11.6991 2.28764 14.9774 1.37299 18.2687 1.63821C21.56 1.90343 24.6495 3.33122 26.9843 5.66606C29.3192 8.0009 30.747 11.0904 31.0122 14.3817C31.2774 17.673 30.3627 20.9513 28.4319 23.6299C26.501 26.3084 23.68 28.2125 20.4737 29.0013C17.2673 29.7901 13.8849 29.4122 10.9317 27.9352L1.60693 31.0434Z"
                    stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </SvgIcon>
    )

    // "Duration"
    const metricLabels = ["Views", "Comments", "Likes"]
    // <PlayCircleOutlineOutlinedIcon />
    const metricIcons = [<RemoveRedEyeOutlinedIcon />, commentsIcon, <FavoriteBorderOutlinedIcon />]
    // formatNumber(videoData.videoDuration)
    const metricValues = [formatNumber(videoData.views), formatNumber(videoData.comments), formatNumber(videoData.likes)]

    // https://firebasestorage.googleapis.com/v0/b/closer-influencer.appspot.com/o/content%2FCrTvC5loLc2.mp4?alt=media
    return (
        <Box sx={style}>
            <Grid container style={{ height: "100%", borderRadius: "20px", }}>
                <Grid item xs={4} sx={{ display: "flex", alignItems: "center", borderRadius: "20px" }}>
                    <CardMedia
                        component='video'
                        // https://firebasestorage.googleapis.com/v0/b/closer-influencer.appspot.com/o/content%2FCVGCDbdIipi.mp4?alt=media
                        image={"https://firebasestorage.googleapis.com/v0/b/closer-influencer.appspot.com/o/content%2F" + videoData.shortcode + ".mp4?alt=media"}
                        controls
                        style={{ borderRadius: "20px", backgroundColor: "black", border: "1px solid black" }}>
                    </CardMedia>
                </Grid>
                <Grid item xs={8} sx={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>
                    <Grid container style={{ padding: "16px" }}>
                        {metricLabels.map((value, index) => (
                            <Grid item xs key={index} sx={{ display: "flex", flexDirection: "column" }}>
                                <Grid item style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "8px", justifyContent: "center", display: "flex" }}>{metricValues[index]}</Grid>
                                <Grid item style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "3px" }}>
                                    {metricIcons[index]}
                                    <Typography >{value}</Typography>
                                </Grid>
                            </Grid>
                        ))}

                        <Grid item xs={12} sx={{ marginTop: "20px", marginBottom: "20px", display: "flex", justifyContent: "center" }}>
                            <Divider style={{ width: "95%" }} />
                        </Grid>

                        <Grid item xs={12} sx={{ marginBottom: "10px", }}>
                            <Typography variant="h6" >Brands promoted in this post</Typography>
                        </Grid>

                        {videoData.brands.map((value, index) => (
                            <Grid item style={{ marginRight: "25px", display: "flex", flexDirection: "column", alignItems: "center" }} key={index}>
                                <Typography><Avatar sx={{ border: "1px solid black", width: "70px", height: "70px", marginBottom: "5px" }} src={"https://firebasestorage.googleapis.com/v0/b/closer-influencer.appspot.com/o/brands%2F" + value + ".jpg?alt=media"} /></Typography>
                                <Typography>{value}</Typography>
                            </Grid>
                        ))}
                        <Grid item xs={10} sx={{ marginTop: "40px" }}>
                            <Typography variant="h7" >{videoData.caption.substring(0, 100)} ...</Typography>
                            <Typography>Caption</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box >
    )
}

export default VideoCard